import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import {FeaturedProductsComponent} from './featured-products.component';
import {ProductsTeaserModule} from '../products-teaser/products-teaser.module';

@NgModule({
  providers: [],
  declarations: [FeaturedProductsComponent],
  imports: [
    CommonModule,
    ProductsTeaserModule
  ],
  exports: [FeaturedProductsComponent]
})
export class FeaturedProductsModule { }
